<template>
  <transition name="fade">
    <SPModal
      v-if="!isApp && !fromApp"
      :displayed="visibility"
      :backdrop="true"
      class="video-popup"
      @close="close"
    >
      <div :style="`position: relative; padding-bottom: ${params.arcadePadding ? params.arcadePadding : 'calc(50.416666666666664% + 41px)'}; height: 0; width: 100%`">
        <iframe
          :src="link"
          frameborder="0"
          loading="lazy"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; color-scheme: light;"
          :title="$brand.label + ' - Espace client'"
        />
      </div>
    </SPModal>
  </transition>
</template>

<script>
import videoPopupService from '@/services/videoPopup';
import SPModal from '@/components/SP/SPModal';
import { mapStores } from 'pinia';
import { useAuthStore } from '@/stores/auth';
import { useVideoPopupStore } from '@/stores/videoPopup';

export default {
  name: 'SpEmbedVideoPopup',
  components: {
    SPModal,
  },
  data() {
    return {
      isMobile: /Mobi/i.test(window.navigator.userAgent),
    };
  },
  computed: {
    ...mapStores(useAuthStore, useVideoPopupStore),
    fromApp() {
      return sessionStorage.getItem('from_app') === 'true' && this.isMobile;
    },
    isApp() {
      if (this.authStore.userAgent) {
        return this.authStore.userAgent.androidWebview || this.authStore.userAgent.iosWebview;
      }
      return false;
    },
    visibility() {
      return this.videoPopupStore.visibility;
    },
    link: {
      cache: false,
      get() {
        return this.videoPopupStore.link;
      },
    },
    params: {
      cache: false,
      get() {
        return this.videoPopupStore.params;
      },
    },
    videoName() {
      return this.videoPopupStore.videoName;
    },
  },
  watch: {
    visibility: {
      handler(val) {
        if (val) {
          videoPopupService.videoPopupSeen({ videoId: this.videoName });
        }
      },
    },
  },
  methods: {
    close() {
      this.videoPopupStore.close({ manually: true });
    },
  },
};
</script>

<style scoped>

</style>
